import {Avatar, Modal} from 'antd'
import {getId, getType} from 'apis/model/base'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useCallback, useContext, useMemo, useState,} from 'react'
import {Link, useLocation} from 'react-router-dom'
import {branch, compose} from 'recompose'
import {ContentNotFound} from 'views/AppLocals/ContentNotFound'
import createContextMenu from 'views/AppLocals/factory/createContextMenu'
import {notifyOnError} from 'views/AppLocals/factory/createErrorEvent'
import {bindQueryParams,} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import {NullAsDefault} from 'views/Shared'
import {useRouteSearchParam} from "../../../../envs/_current/history";
import {useCatholicHouseholds} from "../../../AppLocals/CatholicHousehold/functions/useCatholicHouseholds";
import {catholicHousehold_fetchCatholicHouseholdMembers_Api} from "../../../../apis/catholicHousehold";
import {RiSearchEyeLine, RiUser2Fill} from "react-icons/ri";
import {renderCatholicHouseholdMemberWithSacrament} from "../../../AppLocals/CatholicHousehold/functions/renderCatholicHouseholdMemberWithSacrament";
import {HeaderWithIconLine} from "../../../AppLocals/Templates/items/ListHeader";
import {GoDotFill} from "react-icons/go";
import {BsInfoCircleFill} from "react-icons/bs";
import {renderIf, renderIfElse} from "../../../Shared";
import getTitle from "../../../../helpers/getTitle";
import {ItemInformation} from 'components/common/ItemInformation'
import getLabelOfGender from "../../../../helpers/getLabelOfGender";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import {SacramentTypes} from "../../../AppLocals/CatholicHousehold/consts/SacramentTypes";
import {BaptismSacramentSvg} from "../../../../components/Svgs/BaptismSacramentSvg";
import {FirstCommunionSacramentSvg} from "../../../../components/Svgs/FirstCommunionSacramentSvg";
import {MatrimonySacramentSvg} from "../../../../components/Svgs/MatrimonySacramentSvg";
import {ConfirmationSacramentSvg} from "../../../../components/Svgs/ConfirmationSacramentSvg";
import {HolyOrdersSacramentSvg} from "../../../../components/Svgs/HolyOrdersSacramentSvg";
import {formatDate} from "../../../../helpers/datetimeHelpers";
import LoadingBlock from "../../../Loading/LoadingBlock";
import {AnointingOfTheSickSacramentSvg} from "../../../../components/Svgs/AnointingOfTheSickSacramentSvg";
import classNames from "classnames";
import {FiChevronsRight} from "react-icons/fi";
import {DatePlaceItem} from "../../../../components/common/DatePlaceItem";
import {DoubleValueItem} from "../../../../components/common/DoubleValueItem";

const getSacramentAppearance = (type, size = 30) => {
    let icon, background
    switch (type) {
        case 'baptism':
            icon = <BaptismSacramentSvg size={size} className="text-blue-600"/>;
            background = 'bg-blue-50';
            break
        case 'first_communion':
            icon = <FirstCommunionSacramentSvg size={size} className="text-yellow-600"/>;
            background = 'bg-yellow-50';
            break
        case 'confirmation':
            icon = <ConfirmationSacramentSvg size={size} className="text-primary-600"/>;
            background = 'bg-primary-50';
            break
        case 'matrimony':
            icon = <MatrimonySacramentSvg size={size} className="text-pink-600"/>;
            background = 'bg-pink-50';
            break
        case 'holy_orders':
            icon = <HolyOrdersSacramentSvg size={size} className="text-green-700"/>;
            background = 'bg-green-50';
            break
        case 'anointing_of_the_sick':
            icon = <AnointingOfTheSickSacramentSvg size={size} className="text-secondary-600"/>;
            background = 'bg-secondary-50';
            break
        default:
            break
    }
    return {icon, background}
}


const DetailMemberWithSacramentModal = ({item, onCancel = NullAsDefault, sacrament_type}) => {

    const t = useTranslate()

    const {
        patron_saint_name, name,
        gender, birth_date, birth_province_name,
        father_name, mother_name, member_user,
        sacraments = [], catholic_household,
    } = item ?? {}

    const {icon, background} = getSacramentAppearance(sacrament_type, 36)

    const SacramentInformation = ({type}) => (
        <div className="flex flex-col gap-3">
            <HeaderWithIconLine
                renderTitle={() => (
                    <div className="flex items-center gap-2">
                        <BsInfoCircleFill size={14} className="text-color-500"/>
                        <span className="font-semibold text-sm text-color-400 uppercase tracking-wider">
                                    {t('sacrament information')}
                                </span>
                    </div>
                )}
            />
            <div className="ml-0 md:ml-5 flex flex-col gap-1">
                <div className="flex items-center gap-3">
                    <div className={classNames('p-2 flex flex-center rounded-xl', background)}>
                        {icon}
                    </div>
                    <div className="flex flex-col flex-1">
                                <span className="font-bold text-base text-blue-600 tracking-wide">
                                    {t(_.find(SacramentTypes, {value: sacrament_type})?.label)}
                                </span>
                        <span className="text-xs text-color-300 tracking-wider">
                                    {t(_.find(SacramentTypes, {value: sacrament_type})?.description)}
                                </span>
                    </div>
                </div>
                {sacraments.map((e, i) => {
                    const {eff_date, church_name, officiant_name, participant_name, sacrament_type} = e ?? {}
                    return (
                        renderIf(
                            type === sacrament_type,
                            <div key={i} style={{marginLeft: 10}} className="flex flex-col gap-1">
                                <DatePlaceItem
                                    showIcon={true}
                                    label={type === 'matrimony' ? t('date of celebration') : `${t('date')} ${t(type) || ''}`}
                                    date={formatDate(eff_date, 'DD/MM/YYYY')}
                                    place={church_name}
                                    className="italic tracking-wider"
                                />
                                {renderIf(
                                    officiant_name,
                                    <div className="space-x-1 italic tracking-wider">
                                        <GoDotFill size={10} className="text-color-400"/>
                                        <span className="text-color-500 whitespace-no-wrap">
                                                {`${t('by_prelate')} : `}
                                            </span>
                                        <span className="font-semibold text-color-100">
                                                {officiant_name}
                                            </span>
                                        <span className="text-color-500 whitespace-no-wrap">
                                                {`${t("celebrate")}.`}
                                            </span>
                                    </div>
                                )}
                                {renderIf(
                                    participant_name,
                                    <ItemInformation
                                        showIcon={true}
                                        label={type === 'matrimony' ? 'marriage witnesses' : 'godparent'}
                                        value={participant_name}
                                        className="italic tracking-wider"
                                    />
                                )}
                            </div>
                        )
                    )
                })}
            </div>
        </div>
    )

    const PersonalInformation = () => (
        <div className="flex flex-col gap-3">
            <HeaderWithIconLine
                renderTitle={() => (
                    <div className="flex items-center gap-2">
                        <BsInfoCircleFill size={14} className="text-color-500"/>
                        <span className="font-semibold text-sm text-color-400 uppercase tracking-wider">
                            {t('personal information')}
                        </span>
                    </div>
                )}
            />
            <div className="ml-0 md:ml-5 flex flex-col gap-1">
                <div className="flex items-center gap-3">
                    <Avatar
                        size={30}
                        src={member_user?.avatar}
                        icon={<RiUser2Fill size={16} className="text-color-500"/>}
                        className="flex flex-center background-200"
                    />
                    <div className="flex-1 space-x-1 tracking-wide">
                        <span className="font-medium text-sm text-color-100 italic">
                            {patron_saint_name}
                        </span>
                        <span className="font-bold text-base text-color-000">
                            {renderIfElse(
                                name,
                                name,
                                getTitle(member_user)
                            )}
                        </span>
                    </div>
                </div>
                <div style={{marginLeft: 10}} className="flex flex-col gap-1">
                    <DoubleValueItem
                        showIcon={true}
                        labelFirst="date of birth"
                        valueFirst={formatDate(birth_date, 'DD/MM/YYYY')}
                        labelSecond={birth_province_name ? 'in' : ''}
                        valueSecond={birth_province_name}
                        className="italic tracking-wider"
                    />
                    <ItemInformation
                        showIcon={true}
                        label="gender"
                        value={t(getLabelOfGender(gender))}
                        className="italic tracking-wider"
                    />
                    {(father_name || mother_name) && (
                        <DoubleValueItem
                            showIcon={true}
                            labelFirst="father"
                            valueFirst={father_name}
                            labelSecond={mother_name ? ` - ${t('mother')}` : ''}
                            valueSecond={mother_name}
                            className="italic tracking-wider"
                        />
                    )}

                </div>
            </div>
        </div>
    )

    return (
        <div className="flex flex-col gap-6">

            <SacramentInformation type={sacrament_type}/>
            <PersonalInformation/>

            <div className="p-3 flex gap-x-3 border border-color-50 hover:shadow-md rounded-xl relative">
                <Avatar
                    size={80}
                    src="/images/catholic-household-banner.webp"
                    className="flex flex-center background-200 rounded-lg"
                />
                <div className="flex flex-col flex-1">
                    <Link
                        target="_blank"
                        to={getLinkToDetail(catholic_household)}
                        className="mb-1 font-semibold md:text-sm text-gray-800 no-underline cursor-pointer">
                        {`${t('households')} ${getTitle(catholic_household)}`}
                    </Link>
                    <ItemInformation
                        primary={true} className="text-xs italic" label="number of households"
                        value={catholic_household?.source_idcode}
                    />
                    <div className="flex-1"/>
                    <div className="flex justify-end">
                        <Link
                            target="_blank"
                            to={getLinkToDetail(catholic_household)}
                            className="flex items-center gap-1 text-2xs text-color-400 hover:text-color-100 italic tracking-wide no-underline">
                            {t('view detail')} <FiChevronsRight size={11}/>
                        </Link>
                    </div>
                </div>
            </div>

            <div className="flex justify-end p-3 mt-3">
                <span onClick={onCancel} className="font-medium text-color-200 hover:text-color-000 cursor-pointer">
                    {t('close')}
                </span>
            </div>
        </div>
    )
}


const CatholicHouseholdMemberQuery = ({
                                          owner_id,
                                          owner_type,
                                          sacrament_type,
                                          filter_actions = {
                                              sortBy: 'sort-by',
                                              keyword: 'keyword',
                                          },
                                      }) => {
    const t = useTranslate()
    const history = useHistory()
    const location = useLocation()
    const {isSm} = useContext(LayoutContext)
    const [refreshKey, setRefreshKey] = useState()
    const [action, setAction] = useState({type: undefined, value: undefined,})
    const sortBy = useRouteSearchParam(filter_actions.sortBy)

    const onCancel = () => {
        setAction({})
    }
    const onRefresh = () => {
        setRefreshKey(Date.now())
    }
    const onSuccess = () => {
        setRefreshKey(Date.now())
        onCancel()
    }

    const onError = notifyOnError(t)

    const {onCreate, onUpdate, onDelete, onChangeStatus} = useCatholicHouseholds({
        owner_type, owner_id,
        notifyListeners: {
            onCreated: onSuccess,
            onUpdated: () => {
                setRefreshKey(Date.now())
                onCancel()
            },
            onDeleted: onSuccess,
            onStatusChanged: onSuccess,
        },
    })

    const handleAction = (action, params) => {
        const [id, prop] = [getId(params), getType(params)]

        switch (action) {
            case "CATHOLIC_HOUSEHOLD_MEMBER_VIEW":
                setAction({type: action, value: params})
                break
            default:
                break
        }
    }

    const renderContextMenu = useCallback(
        (item) =>
            createContextMenu(
                [
                    {
                        icon: <RiSearchEyeLine size={14} className="text-color-400"/>,
                        label: <span className="text-sm text-color-200">{t('quick view')}</span>,
                        key: "CATHOLIC_HOUSEHOLD_MEMBER_VIEW",
                    },

                ].filter((e) => !!!e.disable),
                (key) => {
                    handleAction(key, item)
                }
            ),
        []
    )

    const modal = useMemo(() => {
        const {id} = action?.value ?? {}
        let title
        let Content = NullAsDefault
        let Wrapper = ({children}) => children({item: {}})
        let params = {}
        let modal_params = {}
        switch (action?.type) {
            case "CATHOLIC_HOUSEHOLD_MEMBER_VIEW":
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('view information')}
                    </div>
                )
                params = {
                    sacrament_type: sacrament_type,
                    item: action?.value,
                    onCancel,
                }
                modal_params = {
                    width: 640,
                    maskClosable: true,
                    closable: !isSm,
                    className: 'custom-modal'
                }
                Content = DetailMemberWithSacramentModal
                break
            default:
                break
        }

        return (
            <Modal
                footer={null}
                title={title}
                onCancel={onCancel}
                open={action?.type}
                destroyOnHidden={true}
                className="custom-modal"
                {...modal_params}>
                <Wrapper>
                    {({isLoading, item}) => {
                        if (!!isLoading) {
                            return <LoadingBlock/>
                        }
                        return (
                            <Content
                                {...params}
                                {...{owner_id, owner_type}}
                            />
                        )
                    }}
                </Wrapper>
            </Modal>
        )
    }, [action, owner_id, owner_type])

    const refresh_deps = useMemo(
        () => [
            owner_id,
            owner_type,
            refreshKey,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [owner_id, owner_type, refreshKey, location.state]
    )

    const [pager_widget] = usePaginationHelper({
        filter_params: {
            owner_id,
            owner_type,
        },
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onFilterChange({})
            onSortChange(sortBy)
        },
        pagerInfo: {
            RenderEntity: React.Fragment,
            PaginationMeta: NullAsDefault,
            apiInfo: catholicHousehold_fetchCatholicHouseholdMembers_Api,
            query: bindQueryParams([{id: owner_id}, {type: owner_type}]),
            renderItem: renderCatholicHouseholdMemberWithSacrament(
                {
                    translate: t,
                    renderContextMenu,
                    handleAction: (type, value) => {
                        setAction({type, value})
                    },
                },
                sacrament_type,
            ),
            renderWrap: (child) => (
                <div className="mt-2 flex flex-col divide-y divide-gray-200 list-item-workspace">
                    {child}
                </div>
            ),
        },
        withValues: (values) => ({
            ...values,
            sacrament_type,
        }),
        SortByWidget: NullAsDefault,
        renderSortBy: NullAsDefault,
        isToggleDefault: true,
        query_params: filter_actions,
        renderFilter: NullAsDefault,
        AdvancedFilter: NullAsDefault,
        dependencies: [owner_id, owner_type],
        withKey: createPagerKey(refresh_deps),
    })

    const {icon, background} = getSacramentAppearance(sacrament_type, 46)

    return (
        <div className="flex flex-1 flex-col space-y-3">
            <div className="flex items-center gap-3">
                <div className="flex flex-col flex-1">
                    <h2 className="font-bold text-xl text-gray-800 tracking-wide">
                        {t(_.find(SacramentTypes, {value: sacrament_type})?.label)}
                    </h2>
                    <div className="my-1 w-20 h-1 rounded-full bg-gray-400"/>
                    <span className="mt-1 text-color-300 tracking-wider">
                        {t(_.find(SacramentTypes, {value: sacrament_type})?.description)}
                    </span>
                </div>
                <div className={classNames('p-2 flex flex-center shadow-md rounded-xl', background)}>
                    {icon}
                </div>
            </div>
            {pager_widget}
            {modal}
            <div className="h-16"/>
        </div>
    )
}


export default compose(
    branch(
        ({owner_id, owner_type}) => _.some([owner_id, owner_type], _.isEmpty),
        () => () => <ContentNotFound/>
    )
)(CatholicHouseholdMemberQuery)
